import { useCallback } from 'react';
import { push } from 'redux-first-history';
import { trimEnd, trimStart } from 'lodash-es';
import { useDispatch } from '@s20/hooks/redux.hooks';
import { httpClient } from '@s20/services/httpClient';
import authService from '../api-authorization/AuthorizeService';
import { ApiRoutes } from '../Common';

const defaultUrl = '/';

// Permissions, profile and settings are per tenant. A subdomain switch loads the tenant's own host;
// a single-domain switch stores the new tenant and re-runs the app's bootstrap for it.
export const useSwitchTenant = (destinationUrl = defaultUrl) => {
    const dispatch = useDispatch();

    const handleTenantSwitch = useCallback((tenantId) => async () => {
        try {
            const response = await httpClient.put(ApiRoutes.auth.updateTenant(tenantId), {}, httpClient.format.json);

            if (response) {
                sessionStorage.setItem('currentTenantId', tenantId);

                const baseUrl = trimEnd(response.baseUrl, '/');
                const path = `/${trimStart(destinationUrl, '/')}`;

                if (typeof baseUrl === 'string' && baseUrl && baseUrl !== '/') {
                    const dest = `${baseUrl}${path}`;
                    const impersonatingToken = window.sessionStorage.getItem('impersonating');
                    const destUrl = impersonatingToken
                        ? `${dest}${dest.includes('?') ? '&' : '?'}impersonating=${encodeURIComponent(impersonatingToken)}`
                        : dest;
                    window.location.href = destUrl;
                } else {
                    authService.notifySubscribers();
                    dispatch(push(path));
                }
            } else {
                console.error(response);

                // Something happened, so let's try hard refreshing
                window.location.href = '/';
            }
        } catch (e) {
            console.error(e);

            // Something happened, so let's try hard refreshing
            window.location.href = '/';
        }
    }, [destinationUrl, dispatch]);

    return handleTenantSwitch;
};
